const getters = {
  apiToken: (state) => state.user.apiToken,
  identityToken: (state) => state.user.identityToken,
  userInfo: (state) => state.user.userInfo,
  isLogined: (state, getters) => !!getters.userInfo?.user_id,
};
export default getters;
